import angular from "angular"
import routing from "./homepanel.routes"

export class HomePanelController {
  isMobile = window.innerWidth < 1024

  loadLogo = function (campsiteName) {
    return require(`../../assets/logos/${campsiteName}.png`)
  }
}

export default angular
  .module("makeamapAngularApp.homepanel", ["makeamapAngularApp.auth", "ui.router"])
  .config(routing)
  .component("homepanel", {
    template: require("./homepanel.html"),
    bindings: {
      shouldPick: "<",
      campsiteinfo: "<",
      isAvailabilityHidden: "<",
      $transition$: "<",
      $stateParams: "<",
    },
    controller: HomePanelController,
    transclude: false,
  }).name
